import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import CustomButton from "../../../../../components/CustomButton";
import Modal from "./Modal";
import CustomModal from "./Modal";

const FilterContainer = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 16px;
    border-radius: 8px;
    position: relative;
    background-color: white;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 16px;
    border-radius: 8px;
    position: relative;
    background-color: white;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px;
    border-radius: 8px;
    position: relative;
    background-color: white;
  }
`;

const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: relative;
`;

const SelectButton = styled.button`
  display: flex;
  flex-wrap: nowrap;
  padding: 12px 16px;
 border: 1px solid hsla(219, 100%,1%, 0.4);
  border-radius: 8px;
  font-size: ${14 / 16}rem;
  color: ${({ theme }) => theme.palette.greyscale.grey800};
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: hsla(219, 100%, 97%, 0.3);
  text-align: left;
  width: 180px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

  &::after {
    content: "▼";
    font-size: ${10 / 16}rem;
    margin-left: 8px;
    color: ${({ theme }) => theme.palette.greyscale.grey500};
  }

  &:hover {
    border-color: ${({ theme }) => theme.palette.primary.blue500};
    color: ${({ theme }) => theme.palette.primary.blue500};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    width: 100px;
    font-size: ${10 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 100px;
    font-size: ${10 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    width: 180px;
    font-size: ${14 / 16}rem;
  }
`;

const FilterButton = styled.button`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    display: inline-flex; 
    width: auto;
    min-width: 90px;
    padding: 8px 6px;
    margin: 0;
    background-color: ${({ theme }) => theme.palette.primary.blue500};
    color: white;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    transition: all 0.3s ease;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-family: inherit;
    line-height: 1;
    white-space: nowrap;
    font-size: ${12 / 16}rem;
    height: 38px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

    &:hover {
      background-color: hsl(17, 71%, 45%);
      transform: translateY(-1px);
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: ${10 / 16}rem;
    height: 38px;
    padding: 2px 10px;
    width: 80px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    font-size: ${14 / 16}rem;
    height: 44px;
    padding: 2px 8px;
    width: 120px;
  }
`;

export default function ButtonFilters() {
  const history = useHistory();

  
  const getInitialFilterValues = () => {
    const urlParams = new URLSearchParams(window.location.search);
    
    
    const getNumberParam = (paramName: string): number | "" => {
      const value = urlParams.get(paramName);
      const num = value ? Number(value) : "";
      return (typeof num === 'number' && !isNaN(num)) ? num : "";
    };

    return {
      categoria: urlParams.get("imovelType") || "",
      quartos: getNumberParam("rooms"),
      banheiros: getNumberParam("bathrooms"),
      vagas: getNumberParam("garages"),
    };
  };

  const [categoria, setCategoria] = useState<string>(getInitialFilterValues().categoria);
  const [quartos, setQuartos] = useState<number | "">(getInitialFilterValues().quartos);
  const [banheiros, setBanheiros] = useState<number | "">(getInitialFilterValues().banheiros);
  const [vagas, setVagas] = useState<number | "">(getInitialFilterValues().vagas);

  const [modal, setModal] = useState<{
    type: "categoria" | "quartos" | "banheiros" | "vagas" | null;
    isOpen: boolean;
  }>({ type: null, isOpen: false });

  const buttonRefs = {
    categoria: useRef<HTMLButtonElement>(null),
    quartos: useRef<HTMLButtonElement>(null),
    banheiros: useRef<HTMLButtonElement>(null),
    vagas: useRef<HTMLButtonElement>(null),
  };

  
  useEffect(() => {
    const initialValues = getInitialFilterValues();
    setCategoria(initialValues.categoria);
    setQuartos(initialValues.quartos);
    setBanheiros(initialValues.banheiros);
    setVagas(initialValues.vagas);
  }, [window.location.search]);

  const urlParams = new URLSearchParams(window.location.search);
  const uf = urlParams.get("UF") || "";
  const city = urlParams.get("city") || "";
  const neighborhood = urlParams.get("neighborhood") || "";

  const handleApplyFilters = () => {
    if (!uf || !city) {
      console.error("UF e cidade são obrigatórios!"); 
      return;
    }

    let newUrl = `?UF=${uf}&city=${city}`;
    if (neighborhood) newUrl += `&neighborhood=${neighborhood}`;
    if (categoria) newUrl += `&imovelType=${categoria}`;
    if (quartos !== "" && quartos !== 0) newUrl += `&rooms=${quartos}`; 
    if (banheiros !== "" && banheiros !== 0) newUrl += `&bathrooms=${banheiros}`; 
    if (vagas !== "" && vagas !== 0) newUrl += `&garages=${vagas}`; 

    if (window.location.search !== newUrl) {
      history.push(`${window.location.pathname}${newUrl}`);
    }
  };

  const handleSelect = (value: string | number, type: string) => {
    switch (type) {
      case "categoria":
        setCategoria(value as string);
        break;
      case "quartos":
        setQuartos(value as number);
        break;
      case "banheiros":
        setBanheiros(value as number);
        break;
      case "vagas":
        setVagas(value as number);
        break;
      default:
        break;
    }
    setModal({ type: null, isOpen: false });
  };

  const options = {
    categoria: [
      { value: "1", label: "Apartamento" },
      { value: "2", label: "Casa" },
      { value: "3", label: "Flat" },
      { value: "4", label: "Casa de condomínio" },
    ],
    quartos: [1, 2, 3, 4].map((num) => ({
      value: num.toString(),
      label: `${num} quarto${num > 1 ? "s" : ""}`,
    })),
    banheiros: [1, 2, 3, 4].map((num) => ({
      value: num.toString(),
      label: `${num} banheiro${num > 1 ? "s" : ""}`,
    })),
    vagas: [1, 2, 3, 4].map((num) => ({
      value: num.toString(),
      label: `${num} vaga${num > 1 ? "s" : ""}`,
    })),
  };

  return (
    <FilterContainer>
      <SelectContainer>
        <SelectButton
          ref={buttonRefs.categoria}
          onClick={() => setModal({ type: "categoria", isOpen: true })}
        >
          {categoria ? options.categoria.find((opt) => opt.value === categoria)?.label : "Imóvel"}
        </SelectButton>
        {modal.type === "categoria" && modal.isOpen && (
          <CustomModal 
            isOpen={modal.isOpen}
            onClose={() => setModal({ type: null, isOpen: false })}
            options={options.categoria}
            onSelect={(value) => handleSelect(value, "categoria")}
            width={`${buttonRefs.categoria.current?.offsetWidth}px`}
          />
        )}
      </SelectContainer>

      <SelectContainer>
        <SelectButton
          ref={buttonRefs.quartos}
          onClick={() => setModal({ type: "quartos", isOpen: true })}
        >
          {quartos ? `${quartos} quarto${quartos > 1 ? "s" : ""}` : "Quartos"}
        </SelectButton>
        {modal.type === "quartos" && modal.isOpen && (
          <CustomModal 
            isOpen={modal.isOpen}
            onClose={() => setModal({ type: null, isOpen: false })}
            options={options.quartos}
            onSelect={(value) => handleSelect(value, "quartos")}
            width={`${buttonRefs.quartos.current?.offsetWidth}px`}
          />
        )}
      </SelectContainer>

      <SelectContainer>
        <SelectButton
          ref={buttonRefs.banheiros}
          onClick={() => setModal({ type: "banheiros", isOpen: true })}
        >
          {banheiros ? `${banheiros} banheiro${banheiros > 1 ? "s" : ""}` : "Banheiros"}
        </SelectButton>
        {modal.type === "banheiros" && modal.isOpen && (
          <CustomModal 
            isOpen={modal.isOpen}
            onClose={() => setModal({ type: null, isOpen: false })}
            options={options.banheiros}
            onSelect={(value) => handleSelect(value, "banheiros")}
            width={`${buttonRefs.banheiros.current?.offsetWidth}px`}
          />
        )}
      </SelectContainer>

      <SelectContainer>
        <SelectButton
          ref={buttonRefs.vagas}
          onClick={() => setModal({ type: "vagas", isOpen: true })}
        >
          {vagas ? `${vagas} vaga${vagas > 1 ? "s" : ""}` : "Vagas"}
        </SelectButton>
        {modal.type === "vagas" && modal.isOpen && (
          <CustomModal 
            isOpen={modal.isOpen}
            onClose={() => setModal({ type: null, isOpen: false })}
            options={options.vagas}
            onSelect={(value) => handleSelect(value, "vagas")}
            width={`${buttonRefs.vagas.current?.offsetWidth}px`}
          />
        )}
      </SelectContainer>

      <FilterButton onClick={handleApplyFilters}>
        Filtrar
      </FilterButton>
    </FilterContainer>
  );
}
